import styled from 'styled-components';
import colors from 'theme/colors';
import { ICheckProps, ESize, TVariant } from './types';

const SIZE_MAP = {
  [ESize.SM]: '10px',
  [ESize.MD]: '15px',
  [ESize.LG]: '20px',
  [ESize.XL]: '24px',
};

interface IVariantColors {
  icon: string;
  text: string;
  checkedBg: string;
  checkedBorderColor: string;
}

export const checkboxVariants: Record<TVariant, IVariantColors> = {
  default: {
    icon: colors.blue,
    text: colors.gray,
    checkedBg: 'transparent',
    checkedBorderColor: colors.blue,
  },
  success: {
    icon: colors.white,
    text: colors.white,
    checkedBg: colors.green1,
    checkedBorderColor: 'transparent',
  },
};

export const Check = styled.div<ICheckProps>`
  width: ${({ size }) => (size ? SIZE_MAP[size] : SIZE_MAP[ESize.SM])};
  height: ${({ size }) => (size ? SIZE_MAP[size] : SIZE_MAP[ESize.SM])};
  border: 1px solid ${colors.gray3};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.7 : 1)};
`;

export const Label = styled.label<{ disabled: boolean }>`
  display: flex;
  gap: 6px;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.7 : 1)};
`;

export const Input = styled.input<{ variant?: TVariant }>`
  width: 0;
  height: 0;
  visibility: hidden;
  position: absolute;
  z-index: -1;

  &:checked ~ {
    ${Check} {
      border: 1px solid
        ${({ variant }) => (variant ? checkboxVariants[variant].checkedBorderColor : colors.blue)};
      background-color: ${({ variant }) =>
        variant ? checkboxVariants[variant].checkedBg : 'transparent'};
    }
  }
`;
